import styled from "styled-components";

const opensans = (props) => props.theme.fonts.opensans;
const montserrat = (props) => props.theme.fonts.montserrat;

export const FontButton = styled.div`
  width: 100%;
  Button {
    span {
      margin: 2.5px;
      font-family: ${opensans};
      font-size: 0.875rem;
    }
    height: 100%;
    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }
  }
`;

export const HeaderModal = styled.div`
  .MuiDialogTitle-root {
    padding: 0px;
    .MuiTypography-h6 {
      line-height: unset;
    }
  }

  .MuiChip-root {
    margin: 0;
    padding: 10px;
    border-radius: 0px;
    width: 100%;

    .MuiGrid-root {
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        cursor: pointer;
      }
    }

    .MuiChip-label {
      width: 100%;
      align-items: center;
      justify-content: center;
      display: flex !important;
      font-family: ${montserrat}, sans-serif;
      font-size: 0.975rem;
    }
  }
`;
